import { colors } from '../../../../packages/colors';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  section: ({ isUpcomingAppointment }) => ({
    display: 'flex',
    flexDirection: 'column',
    padding: isUpcomingAppointment ? '24px 0px 24px 0px' : '24px 0px',
    '&:first-child': {
      paddingTop: isUpcomingAppointment && '0px',
    },
  }),
  sectionHeader: {
    padding: '16px 0',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  sectionContent: {
    paddingLeft: 32,
    paddingRight: 0,
    paddingBottom: 8,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  descriptionText: {
    fontSize: 16,
    lineHeight: '24px',
    color: colors.neutral900,
    fontWeight: 500,
  },
  markdownContent: {
    fontSize: 14,
    lineHeight: '24px',
    color: colors.neutral900,
    fontWeight: 500,
    '& strong': {
      fontSize: 14,
      fontWeight: 600,
    },
    '& p': {
      margin: 0,
      marginBottom: 8,
      '&:last-child': {
        marginBottom: 0,
      },
    },
    '& ul': {
      margin: 0,
      paddingLeft: 20,
    },
  },
  lastUpdatedText: {
    fontSize: 14,
    lineHeight: '20px',
    color: colors.neutral500,
    fontWeight: 400,
  },
  viewLink: {
    fontSize: 14,
    lineHeight: '24px',
    color: colors.primary500,
    fontWeight: 600,
    cursor: 'pointer',
    display: 'inline-block',
    width: 'fit-content',
  },
  divider: {
    height: 1,
    backgroundColor: colors.neutral100,
    width: '100%',
  },
  evaluationsList: {
    paddingLeft: 32,
    paddingTop: 8,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  evaluationCard: {
    padding: '16px',
    backgroundColor: colors.primary50,
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: colors.primary100,
    },
  },
  chatbotCard: {
    padding: '16px 4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.7,
    },
  },
  lottieSize: {
    width: 80,
    height: 80,
  },
  constructsHeader: {
    paddingTop: '16px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
});

export const sxStyles = {
  assignEvaluations: {
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.7,
    },
  },
};
